module.exports = __webpack_public_path__ + "static/media/tick-blue.cbd34873.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tick-blue.svg
// module id = 149
// module chunks = 0